import { render } from "./RewardCatalogue.vue?vue&type=template&id=b52c7404&scoped=true"
import script from "./RewardCatalogue.vue?vue&type=script&lang=js"
export * from "./RewardCatalogue.vue?vue&type=script&lang=js"

import "./RewardCatalogue.vue?vue&type=style&index=0&id=b52c7404&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52c7404"]])

export default __exports__